(function () {
    'use strict';

    angular
        .module('app.mentionManagementLog', [])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.mentionManagementLog', {
                    requireLogin: true,
                    url: 'mention/mentionManagementLog',
                    templateUrl: 'app/admin/mention/mentionManagementLog/mentionManagementLog.html?app_v=deployDate',
                    controller: 'mentionManagementLogCtrl',
                    scope: {},
                    data: {
                        authorizedRoles: ['Administrator', 'Achoo Analyst'],
                        navMarker: ['admin', 'mentionManagementLog']
                    },
                    params: {
                        
                    }
                });
        }]);
})();